module.exports = __webpack_public_path__ + "img/mortgage.cc31e65.png";